type BrandPalette = {
  brand: string;
  "600": string;
  "700": string;
  soft: string;
  soft2: string;
};

export const BRAND_PRESETS: Record<string, BrandPalette> = {
  "#2f5fd8": {
    brand: "#2f5fd8",
    "600": "#1e45aa",
    "700": "#17357f",
    soft: "#eaf1fe",
    soft2: "#dceaff",
  },
  "#1b4ed8": {
    brand: "#1b4ed8",
    "600": "#1740b8",
    "700": "#122f8a",
    soft: "#eaf0ff",
    soft2: "#d6e1ff",
  },
  "#7c56f5": {
    brand: "#7c56f5",
    "600": "#6838e0",
    "700": "#5627bb",
    soft: "#f1ecff",
    soft2: "#dccfff",
  },
  "#0d8a8a": {
    brand: "#0d8a8a",
    "600": "#0a7373",
    "700": "#075959",
    soft: "#e2f4f4",
    soft2: "#c6e7e7",
  },
  "#1f1f25": {
    brand: "#1f1f25",
    "600": "#121217",
    "700": "#000000",
    soft: "#eeeef1",
    soft2: "#d8d8de",
  },
};

function hexToRgb(hex: string): string {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}

export function applyBrandColor(hex: string): void {
  const p = BRAND_PRESETS[hex] ?? BRAND_PRESETS["#2f5fd8"]!;
  const r = document.documentElement.style;
  r.setProperty("--brand", p.brand);
  r.setProperty("--brand-600", p["600"]);
  r.setProperty("--brand-700", p["700"]);
  r.setProperty("--brand-soft", p.soft);
  r.setProperty("--brand-soft-2", p.soft2);
  const c = hexToRgb(p.brand);
  r.setProperty(
    "--sh-brand",
    `0 12px 28px rgba(${c}, 0.32), 0 4px 10px rgba(${c}, 0.18)`,
  );
}
